import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HttpService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Component({
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CarrierAutoCompleteFieldComponent),
      multi: true,
    },
  ],
  selector: 'app-carrier-auto-complete-field',
  templateUrl: './carrier-auto-complete-field.component.html',
  styleUrls: ['./carrier-auto-complete-field.component.scss']
})
export class CarrierAutoCompleteFieldComponent implements OnInit, ControlValueAccessor {

  @Input() label!: string;

  @Input() required: boolean = false;

  @Input() showOthersOption: boolean = false;

  @Input() grow: boolean;

  @Input() disableAutoComplete: boolean = false;

  public readonly formControl = new FormControl(null, []);

  filteredCarriers: any;

  constructor(
    public translationService: TranslationService,
    private http: HttpService
  ) { }

  public ngOnInit(): void {

    this.formControl.valueChanges.pipe(
      debounceTime(300),
      tap(() => {
        const value = this._getValue();
        this._onChange(value);
      }),
      switchMap(value => this.http.postWithContext(`${environment.autocompletionEndpoint}/carriers`, value))
    ).subscribe(result => { this.filteredCarriers = result; });

  }

  /** Return a Date if the fields are ready or null otherwise */
  private _getValue(): string | null {
    try {
      if (this.formControl.invalid) {
        return null;
      }

      return this.formControl.value;
    } catch {
      // Return null if something throws
      return null;
    }
  }

  public writeValue(value: string | null): void {
    console.log('writing value', value);
    if (value != null) {
      this.formControl.setValue(value);
    } else {
      this.formControl.setValue(null);
    }
  }

  private _onChange = (_value: string | null): void => undefined;
  public registerOnChange(fn: (value: string | null) => void): void {
    this._onChange = fn;
  }

  /** It's called in the component template when we have a "blur" or "input" event */
  public onTouched = (): void => undefined;
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

}
